import { gameTopLupe, RENDER_TEMP } from '@page_detail/config'

export const game_detail_configs = {
  games: [...RENDER_TEMP], // 所有游戏
  has_desktopDetail_games: [...RENDER_TEMP], // 有专有pc适配的游戏
  has_mobileDetail_games: [
    'lordsmobile',
    'infinity-kingdom',
    'state-of-survival',
    'infinity-war',
  ], // 移动端游戏
  desktop_display_mobile: ['lordsmobile'], //在pc端需要展示h5的游戏
  has_gameTurbo_games: [
    gameTopLupe, // 用于钱包的gt模式
    ...RENDER_TEMP,
  ], // 有game turbo模式展示的游戏
  has_coupon_games: [...RENDER_TEMP],
  no_sku_games: ['state-of-survival'], // 没有sku的游戏
}
